export const Config = {
    baseUrl: "https://math-exercise.johnwu.cc",
    fbAppId: "1046791958755149"
};